
/**
 * External dependencies
 */
import classnames from 'classnames';
import simpleParallax from 'simple-parallax-js';
import {
	toString,
	get,
	pick,
	map,
	find,
	every,
	filter,
} from 'lodash';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper React components
import { Navigation, Pagination, EffectCoverflow, EffectCube, EffectFade, EffectFlip, EffectCards, A11y, Autoplay, Lazy } from 'swiper';

/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import {
	BlockControls,
	useInnerBlocksProps,
	__experimentalUseInnerBlocksProps,
	useBlockProps,
	InspectorControls,
	InnerBlocks,
	BlockList,
	BlockEditorProvider,
	MediaPlaceholder,
	MediaUpload,
	MediaUploadCheck,
	useBlockEditContext,
} from '@wordpress/block-editor';
import {
	forwardRef,
	useState,
	useEffect,
	useLayoutEffect,
	useRef,
	useReducer,
	Fragment,
	createRef,
	Platform,
	RawHTML,
	useCallback,
} from '@wordpress/element';
import {
	createBlock,
	getBlockContent,
} from '@wordpress/blocks';
import {
	useDispatch,
	useSelect,
	withSelect,
	withDispatch,
	subscribe,
	select,
} from '@wordpress/data';
import {
	compose,
} from '@wordpress/compose';
import { useEntityBlockEditor } from '@wordpress/core-data';
import {
	withNotices,
	Button,
	__experimentalBoxControl as BoxControl,
	Placeholder,
} from '@wordpress/components';
import { View } from '@wordpress/primitives';
import { getBlobByURL, isBlobURL, revokeBlobURL } from '@wordpress/blob';
import {
	store,
	withViewportMatch,
} from '@wordpress/viewport';
import ServerSideRender from '@wordpress/server-side-render';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import '../editor.scss';
// import 'lightgallery/scss/lightgallery.scss';

// import GutenSwiper from '../components/GutenSwiper';
import GutensliderInspectorControls from './inspector-controls';
import GutensliderBlockControls from './block-controls';
import icons from '../../icons';
import { defaultBackground, emptyBackground } from '../../../components/reusable/background/attributes';
import { hexToRgb, getPositionClassName, updateDotsAndSetAttributes } from '../../utils';
import { AutoSlidesContext } from '../../context';

// import 'swiper/swiper.scss';
// import 'swiper/components/navigation/navigation.scss';
// import 'swiper/components/pagination/pagination.scss';
// import 'swiper/components/scrollbar/scrollbar.scss';

const TEMPLATE = [
    [ 'eedee/block-gutenslide', {}, [
        [ 'core/paragraph', { placeholder: 'Enter slide content...' } ],
    ] ],
    [ 'eedee/block-gutenslide', {}, [
        [ 'core/paragraph', { placeholder: 'Enter slide content...' } ],
    ] ]
];

const DIVIDER_OPTIONS = eedeeGutenslider.gutensliderDividers;
const ALLOWED_MEDIA_TYPES = [ 'image', 'video' ];

const PLACEHOLDER_TEXT = Platform.select( {
	web: __(
		'Drag images, upload new ones or select files from your library.'
	),
	native: __( 'ADD MEDIA' ),
} );

const pickRelevantMediaFiles = ( image, sizeSlug = 'large' ) => {
	const imageProps = pick( image, [
		'alt',
		'id',
		'link',
		'title',
		'description',
		'caption',
		'media_type',
		'type',
		'width',
		'height',
		'mime',
	] );
	imageProps.url =
		get( image, [ 'sizes', sizeSlug, 'url' ] ) ||
		get( image, [ 'media_details', 'sizes', sizeSlug, 'source_url' ] ) ||
		image.url;
	const fullUrl =
		get( image, [ 'sizes', 'full', 'url' ] ) ||
		get( image, [ 'media_details', 'sizes', 'full', 'source_url' ] );
	if ( fullUrl ) {
		imageProps.fullUrl = fullUrl;
	}
	return imageProps;
};

function Edit( props ) {

	const {
		clientId,
		selectActiveBlock,
		selectBlock,
		index,
		getBlockOrder,
		attributes,
		getParentBlock,
		isSelected,
		hasSelectedInnerBlock,
		onFocus,
		noticeUI,
		replaceInnerBlocks,
		innerBlocks,
		className,
		updateBlockIds,
		newDeviceType,
		getParentId,
		isStackSelected,
		updateCaptions,
	} = props;

	const {
		gsBlockId,
		media,
		contentMode,
		animation,
		fadeMode,
		duration,
		arrows,
		arrowsMd,
		arrowsSm,
		arrowStyle,
		dotStyle,
		dots,
		dotsMd,
		dotsSm,
		pauseOnFocus,
		pauseOnHover,
		pauseOnDotsHover,
		dotSize,
		dotSizeMd,
		dotSizeSm,
		arrowSize,
		arrowSizeMd,
		arrowSizeSm,
		arrowColor,
		arrowBgColor,
		arrowHoverColor,
		arrowBgHoverColor,
		arrowXOffset,
		arrowXOffsetMd,
		arrowXOffsetSm,
		arrowYOffset,
		arrowYOffsetMd,
		arrowYOffsetSm,
		arrowPosition,
		arrowMixBlendMode,
		arrowXSpacing,
		dotColor,
		dotYOffset,
		dotYOffsetMd,
		dotYOffsetSm,
		slidesToShow,
		slidesToShowMd,
		slidesToShowSm,
		slidesToScroll,
		slidesToScrollMd,
		slidesToScrollSm,
		sliderHeight,
		sliderHeightMd,
		sliderHeightSm,
		paddingX,
		paddingXMd,
		paddingXSm,
		paddingY,
		paddingYMd,
		paddingYSm,
		marginX,
		marginXMd,
		marginXSm,
		marginY,
		marginYMd,
		marginYSm,
		spacingXMobile,
		spacingYMobile,
		spacingXTablet,
		spacingYTablet,
		spacingXDesktop,
		spacingYDesktop,
		spacingXUnit,
		spacingYUnit,
		isFullScreen,
		fadeSpeed,
		hasParallax,
		parallaxDirection,
		parallaxAmount,
		autoplay,
		mixBlendMode,
		contentOpacity,
		isEditing,
		rgbaBackground,
		loop,
		adaptiveHeight,
		adaptiveHeightMd,
		adaptiveHeightSm,
		contentPosition,
		zoom,
		spaceBetween,
		spaceBetweenMd,
		spaceBetweenSm,
		centeredSlides,
		dotType,
		dotPosition,
		autoCaption,
		isVertical,
		dividers,
		//dimensionControl
		style: styleAttribute,
	} = attributes;

	const ref = useRef();
	const wrapperRef = useRef();
	const { getBlocks } = useSelect( ( select ) => select( 'core/block-editor' ) );

	const [ swiper, setSwiper ] = useState( null );
	const [ swiperUpdateKey, setSwiperUpdateKey ] = useState( 1 );
	const [ slides, setSlides ] = useState( [] );
	const [ activeSlide, setActiveSlide ] = useState( {
		index: 0,
		blockId: null,
	} );
	const [ deviceType, setDeviceType ] = useState( 'Desktop' );

	// const rerenderProps = [
	// 	'align',
	// 	'sliderHeight',
	// 	'sliderHeightMd',
	// 	'sliderHeightSm',
	// 	'slidesToShow',
	// 	'slidesToShowMd',
	// 	'slidesToShowSm',
	// 	'slidesToScroll',
	// 	'slidesToScrollMd',
	// 	'slidesToScrollSm',
	// 	'animation',
	// 	'fadeSpeed',
	// 	'loop',
	// 	'zoom',
	// 	'spaceBetween',
	// 	'spaceBetweenMd',
	// 	'spaceBetweenSm',
	// 	'centeredSlides',
	// 	'isEditing',
	// 	'contentMode',
	// 	'adaptiveHeight',
	// 	'adaptiveHeightMd',
	// 	'adaptiveHeightSm',
	// 	'dotType',
	// 	'hasParallax',
	// 	'parallaxDirection',
	// 	'parallaxAmount',
	// 	'duration',
	// 	'autoplay',
	// 	'dotPosition',
	// 	'isVertical',
	// ];

	// useEffect( () => {
	// 	setSwiperUpdateKey( Math.random() );
	// 	swiper?.update();
	// }, [ deviceType, ...rerenderProps.map( ( name )  => attributes[ name ] ) ] );
	const innerSlides = filter( innerBlocks, { name: 'eedee/block-gutenslide' } );

	useEffect( () => {
		updateBlockIds();
	}, [] );

	useEffect( () => {
		swiper?.update();
	}, [ slides ] );

	useEffect( () => {
		setSwiperUpdateKey( Math.random() );
		swiper?.update();
	}, [
		// isStackSelected,
		contentMode,
		sliderHeight,
		sliderHeightMd,
		sliderHeightSm,
		slidesToShow,
		slidesToShowMd,
		slidesToShowSm,
		slidesToScroll,
		slidesToScrollMd,
		slidesToScrollSm,
		animation,
		fadeSpeed,
		loop,
		zoom,
		spaceBetween,
		spaceBetweenMd,
		spaceBetweenSm,
		centeredSlides,
		// isEditing,
		adaptiveHeight,
		adaptiveHeightMd,
		adaptiveHeightSm,
		dotType,
		hasParallax,
		parallaxDirection,
		parallaxAmount,
		duration,
		autoplay,
		dotPosition,
		isVertical,
	]);

	// useEffect( () => {
	// 	// select child slide when active Index changes unless
	// 	// the parent block is currently selected
	// 	if ( ! isSelected && hasSelectedInnerBlock ) {
	// 		selectBlock( activeSlide.blockId, -1);
	// 	}
	// }, [ activeSlide.index ] );

	// useEffect( () => {
	// 	// if gs block or any child is selected pause autoplay
	// 	// todo can this be done better?
	// 	setSwiperUpdateKey( Math.random() );
	// }, [ isStackSelected ]);

	// useLayoutEffect(() => {
	// 	updateParallax();
	// }, [ swiperUpdateKey ])>

	useEffect( () => {
		if (
			Platform.OS === 'web' &&
			media &&
			media.length > 0 &&
			every( media, ( { url } ) => isBlobURL( url ) )
		) {
			const filesList = map( media, ( { url } ) => getBlobByURL( url ) );
			forEach( media, ( { url } ) => revokeBlobURL( url ) );
			mediaUpload( {
				filesList,
				onFileChange: onSelectMedia,
				allowedTypes: [ 'image' ],
			} );
		}
	}, [] );

	useEffect( () => {
		updateCaptions( autoCaption );
	}, [ autoCaption ]);

	useEffect( () => {
		if ( isVertical && dotType === 'dynamic' ) {
			updateDotsAndSetAttributes( gsBlockId, { dotType: 'bullets' }, setAttributes );
		}
	}, [ isVertical ]);

	const isBlockIdUnique = ( idInQuestion ) => getBlocks().filter(
		( { attributes: { gsBlockId: otherId } } ) =>
			otherId !== undefined && otherId === idInQuestion
	).length <= 1

	function setAttributes( newAttrs ) {
		if ( newAttrs.ids ) {
			throw new Error(
				'The "ids" attribute should not be changed directly. It is managed automatically when "images" attribute changes'
			);
		}

		if ( newAttrs.media ) {
			newAttrs = {
				...newAttrs,
				// Unlike media[ n ].id which is a string, always ensure the
				// ids array contains numbers as per its attribute type.
				ids: map( newAttrs.media, ( { id } ) => parseInt( id, 10 ) ),
			};
		}

		props.setAttributes( newAttrs );
	}

	function onSelectMedia( newMedia ) {
		const filteredMedia = newMedia.map( ( newImage ) => ( {
			...pickRelevantMediaFiles( newImage ),
			id: toString( newImage.id ),
		} ) );

		setAttributes( {
			media: filteredMedia,
		} );

		const newInnerSlides = [];

		if ( innerBlocks.length ) {
			filteredMedia.map( ( medium ) => {
				let mediaType, newBlockAttributes;

				// for media selections originated from a file upload.
				if ( medium.media_type ) {
					if ( medium.media_type === 'image' ) {
						mediaType = 'image';
					} else {
						// only images and videos are accepted so if the media_type is not an image we can assume it is a video.
						// video contain the media type of 'file' in the object returned from the rest api.
						mediaType = 'video';
					}
				} else { // for media selections originated from existing files in the media library.
					mediaType = medium.type;
				}

				if ( medium.id ) {
					const found = innerSlides.find( ( block ) => {
						return medium.id === block.attributes.background.mediaId;
					} );

					if ( found ) {
						newInnerSlides.push( found );
					} else {
						if ( mediaType === 'image' ) {
							newBlockAttributes = {
								gsBlockId: Math.random().toString( 36 ).substr( 2, 9 ),
								contentPosition,
								background: {
									...defaultBackground,
									backgroundType: 'image',
									backgroundImage: medium,
									backgroundVideo: {},
									mediaId: medium.id,
								},
							};
						} else if ( mediaType === 'video' ) {
							newBlockAttributes = {
								gsBlockId: Math.random().toString( 36 ).substr( 2, 9 ),
								contentPosition,
								background: {
									...defaultBackground,
									backgroundType: 'video',
									backgroundVideo: medium,
									backgroundImage: {},
									mediaId: medium.id,
								},
							};
						}

						const created = createBlock( 'eedee/block-gutenslide', newBlockAttributes );
						newInnerSlides.push( created );
					}
				}
			} );

			//the slider might have other blocks than slides, if it has fixed content ...
			const otherBlocks = [];

			innerBlocks.map( ( block ) => {
				if ( block.name !== 'eedee/block-gutenslide' ) {
					otherBlocks.push( block );
				}
			} );

			newInnerSlides.push( ...otherBlocks );

		} else {

			filteredMedia.map( ( medium ) => {
				let mediaType, newBlockAttributes;

				// for media selections originated from a file upload.
				if ( medium.media_type ) {
					if ( medium.media_type === 'image' ) {
						mediaType = 'image';
					} else {
						// only images and videos are accepted so if the media_type is not an image we can assume it is a video.
						// video contain the media type of 'file' in the object returned from the rest api.
						mediaType = 'video';
					}
				} else { // for media selections originated from existing files in the media library.
					mediaType = medium.type;
				}

				if ( mediaType === 'image' ) {
					newBlockAttributes = {
						gsBlockId: Math.random().toString( 36 ).substr( 2, 9 ),
						contentPosition,
						background: {
							...defaultBackground,
							backgroundType: 'image',
							backgroundImage: medium,
							backgroundVideo: {},
							mediaId: medium.id,
						},
					};
				} else if ( mediaType === 'video' ) {
					newBlockAttributes = {
						gsBlockId: Math.random().toString( 36 ).substr( 2, 9 ),
						contentPosition,
						background: {
							...defaultBackground,
							backgroundType: 'video',
							backgroundVideo: medium,
							backgroundImage: {},
							mediaId: medium.id,
						},
					};
				}

				const created = createBlock( 'eedee/block-gutenslide', newBlockAttributes );
				newInnerSlides.push( created );
			} );
		}

		replaceInnerBlocks( clientId, newInnerSlides, false );
		setActiveSlide( {
			index: 0,
			blockId: getBlockOrder( clientId )[ 0 ],
		} );
	}

	function onUploadError( message ) {
		noticeOperations.removeAllNotices();
		noticeOperations.createErrorNotice( message );
	}

	function updateParallax() {
		if ( hasParallax ) {
			const images = wrapperRef.current?.querySelectorAll( '.eedee-background-div img, .eedee-background-div video');
			const customContainer = document.querySelector('.interface-interface-skeleton__content');

			// new simpleParallax( images, {
			// 		scale: parallaxAmount,
			// 		orientation: parallaxDirection,
			// 		customContainer,
			// } );
		}
	}

	function insertEmptySlide() {
		const blockToInsert = createBlock( 'eedee/block-gutenslide', {
			background: emptyBackground,
			contentPosition,
		} );
		const newSlides = [ ...getBlocks( clientId ), blockToInsert ];
		setSlides( newSlides );
		replaceInnerBlocks( clientId, [ ...getBlocks( clientId ), blockToInsert ] );
		setActiveSlide( {
			index: newSlides.length,
			blockId: blockToInsert.clientId,
		} );
		setSwiperUpdateKey( Math.random() );
		swiper && swiper.update();
		selectBlock( blockToInsert.clientId );
	}

	const getPrevArrow = () => {
		const arrowClasses = classnames(
			'eedee-gutenslider-nav',
			'eedee-gutenslider-prev',
		);

		let prevArrow = '<';

		if ( window.eedeeGutenslider &&
			eedeeGutenslider.arrows &&
			find( eedeeGutenslider.arrows, { value: arrowStyle } )
		) {
			let a = find( eedeeGutenslider.arrows, { value: arrowStyle } )['prev'];
			if ( a ) {
				prevArrow = <RawHTML>{ a }</RawHTML>;
			}
		}

		return (
			<button
				className={ arrowClasses }
			>
				{ prevArrow }
			</button>
		);
	};

	const getNextArrow = () => {
		const arrowClasses = classnames(
			'eedee-gutenslider-nav',
			'eedee-gutenslider-next',
		);

		let nextArrow = '>';

		if ( window.eedeeGutenslider &&
			eedeeGutenslider.arrows &&
			find( eedeeGutenslider.arrows, { value: arrowStyle } )
		) {
			let a = find( eedeeGutenslider.arrows, { value: arrowStyle } )['next'];
			if ( a ) {
				nextArrow = <RawHTML>{ a }</RawHTML>;
			}
		}
		return (
			<div
				className={ arrowClasses }
			>
				{ nextArrow }
			</div>
		);
	};

	const getPagination = () => {
		return <div
			className="eedee-gutenslider-pagination swiper-pagination"
		></div>;
	};

	function getSlidesPerView ( slidesBreakpoint ) {
		if ( animation === 'fade' ||
			animation === 'cube' ||
			animation === 'cards' ||
			animation === 'flip' ) {
			return 1;
		}
		if ( slidesBreakpoint === 0 ) {
			return 'auto';
		}

		return slidesBreakpoint;
	}

	function getResponsiveSlidesPerView() {
		const rsvpMap = {
			Desktop: getSlidesPerView( slidesToShow ),
			Tablet: getSlidesPerView( slidesToShowMd ),
			Mobile: getSlidesPerView( slidesToShowSm ),
		};

		const rspv = Object.keys( rsvpMap ).indexOf( newDeviceType ) !== -1 ?
			rsvpMap[ newDeviceType ] : 1;

		return rspv;
	};

	function isResponsiveAdaptiveHeight() {
		if ( isVertical ) {
			return false;
		}

		const rahMap = {
			Desktop: adaptiveHeight,
			Tablet: adaptiveHeightMd,
			Mobile: adaptiveHeightSm,
		};

		const ret = Object.keys( rahMap ).indexOf( newDeviceType ) !== -1 ?
			rahMap[ newDeviceType ] : false;

		return ret;
	};

	let swiperBreakpoints = {};

	if ( newDeviceType === 'Desktop' ) {
		swiperBreakpoints = {
			slidesPerView: getSlidesPerView( slidesToShow ),
			slidesPerGroup: slidesToScroll,
			spaceBetween: animation === 'cube' ? 0 : spaceBetween,
		};
	} else if ( newDeviceType === 'Tablet' ) {
		swiperBreakpoints = {
			slidesPerView: getSlidesPerView( slidesToShowMd ),
			slidesPerGroup: slidesToScrollMd,
			spaceBetween: animation === 'cube' ? 0 : spaceBetweenMd,
		};
	}

	function isChild(element, classname) {
		if (typeof element.className !== 'object' && // SVGs are weird, man.
				element.className.split(' ').indexOf(classname) >= 0) {
			return true;
		} else if (element.tagName !== 'HTML') { // If you've reached the body, you've gone too far
			return element.parentNode && isChild(element.parentNode, classname);
		} else {
			return false;
		}
	}

	function onSliderClick( e ) {
		if ( contentMode === 'fixed' && isChild( e.target, 'swiper-slide' ) ) {
			if ( ! isSelected && ! hasSelectedInnerBlock ) {
				selectBlock( clientId );
			} else {
				selectBlock( activeSlide.blockId );
			}
		}
	}

	//migrate older versions successfully
	const animationEffect = fadeMode ? 'fade' : animation;
	const progressbarOpposite =
		isVertical && ( dotPosition === 'dot-position-top' || dotPosition === 'dot-position-bottom' )
		|| ! isVertical && ( dotPosition === 'dot-position-left' || dotPosition === 'dot-position-right' );

	const swiperProps = {
		initialSlide: activeSlide.index,
		// autoplay: autoplay && ! isStackSelected ? {
		// 	delay: duration * 1000,
		// } : false,
		autoplay: false,
		speed: fadeSpeed * 1000,
		direction: isVertical ? 'vertical' : 'horizontal',
		autoHeight: isResponsiveAdaptiveHeight(),
		loop: false,
		loopedSlides: slides.length,
		centeredSlides: animation === 'coverflow' || centeredSlides,
		spaceBetween: animation === 'cube' ? 0 : spaceBetweenSm,
		slidesPerView: getSlidesPerView( slidesToShowSm ),
		slidesPerGroup: slidesToScrollSm,
		effect: animation,
		observer: false,
		observeParents: false,
		fadeEffect: {
			crossFade: true,
		},
		noSwipingSelector: 'p, input, li, h1, h2, h3, h4, h5, h6',
		zoom: zoom,
		navigation: {
			nextEl: `#gutenslider-${ gsBlockId } .eedee-gutenslider-next`,
			prevEl: `#gutenslider-${ gsBlockId } .eedee-gutenslider-prev`,
		},
		pagination: {
			type: dotType === 'dynamic' ? 'bullets' : dotType,
			clickable: true,
			dynamicBullets: dotType === 'dynamic',
			el: `#gutenslider-${ gsBlockId } .eedee-gutenslider-pagination`,
			progressbarOpposite,
		},
		onAfterInit: ( swiper ) => {
			setActiveSlide( {
				index: swiper.activeIndex,
				blockId: getBlockOrder( clientId )[ swiper.activeIndex ],
			} );
		},
		onTransitionEnd: ( swiper ) => {
			setActiveSlide( {
				index: swiper.activeIndex,
				blockId: getBlockOrder( clientId )[ swiper.activeIndex ],
			} );
		},
		onLazyImageReady: ( swiper ) => {
			swiper.update();
		},
		...swiperBreakpoints,
	};

	const classes = classnames(
		className, {
			[ `content-${ contentMode }` ]: contentMode,
			'adaptive-height': isResponsiveAdaptiveHeight(),
			'fixed-height': ! isResponsiveAdaptiveHeight(),
			'has-parallax': ! isFullScreen && hasParallax,
			[ `${ arrowStyle }` ]: arrowStyle,
			[ `${ arrowPosition }` ]: arrowPosition,
			'arrows-lg': arrows,
			'arrows-md': arrowsMd,
			'arrows-sm': arrowsSm,
			'arrows-lg-none': ! arrows,
			'arrows-md-none': ! arrowsMd,
			'arrows-sm-none': ! arrowsSm,
			[ `arrow-mb-${ arrowMixBlendMode }` ]: arrowMixBlendMode,
			[ `${ dotStyle }` ]: dotStyle,
			'dots-lg': dots,
			'dots-md': dotsMd,
			'dots-sm': dotsSm,
			'dots-lg-none': ! dots,
			'dots-md-none': ! dotsMd,
			'dots-sm-none': ! dotsSm,
			[ `${ dotPosition }` ]: dotPosition,
			'slides-auto': getResponsiveSlidesPerView() === 'auto',
			'slides-number': getResponsiveSlidesPerView() !== 'auto',
			[ `mb-${ mixBlendMode }` ]: mixBlendMode,
		},
		getPositionClassName( contentPosition ),
	);

	const outerClasses = classnames(
		'eedee-swiper-outer',
		{
			'swiper-vertical': isVertical,
			'swiper-horizontal': ! isVertical,
		}
	)

	const componentStyle = {
		'--gutenslider-min-height': `${ sliderHeight }`,
		'--gutenslider-min-height-md': `${ sliderHeightMd }`,
		'--gutenslider-min-height-sm': `${ sliderHeightSm }`,
		'--gutenslider-arrow-size': `${ arrowSize }px`,
		'--gutenslider-arrow-size-md': `${ arrowSizeMd }px`,
		'--gutenslider-arrow-size-sm': `${ arrowSizeSm }px`,
		'--gutenslider-arrow-color': `${ arrowColor }`,
		'--gutenslider-arrow-bg-color': arrowBgColor ? `${ arrowBgColor }` : 'transparent',
		'--gutenslider-arrow-hover-color': arrowHoverColor ? `${ arrowHoverColor }` : 'transparent',
		'--gutenslider-arrow-bg-hover-color': arrowBgHoverColor ? `${ arrowBgHoverColor }` : 'transparent',
		'--gutenslider-arrow-x-offset': `${ arrowXOffset }px`,
		'--gutenslider-arrow-x-offset-md': `${ arrowXOffsetMd }px`,
		'--gutenslider-arrow-x-offset-sm': `${ arrowXOffsetSm }px`,
		'--gutenslider-arrow-y-offset': `${ arrowYOffset }px`,
		'--gutenslider-arrow-y-offset-md': `${ arrowYOffsetMd }px`,
		'--gutenslider-arrow-y-offset-sm': `${ arrowYOffsetSm }px`,
		'--gutenslider-arrow-x-spacing': `${ arrowXSpacing }px`,
		'--gutenslider-dot-size': `${ dotSize }px`,
		'--gutenslider-dot-size-md': `${ dotSizeMd }px`,
		'--gutenslider-dot-size-sm': `${ dotSizeSm }px`,
		'--gutenslider-dot-color': `${ dotColor }`,
		'--gutenslider-dot-y-offset': `${ dotYOffset }px`,
		'--gutenslider-dot-y-offset-md': `${ dotYOffsetMd }px`,
		'--gutenslider-dot-y-offset-sm': `${ dotYOffsetSm }px`,
		'--gutenslider-padding-x': `${ paddingX }`,
		'--gutenslider-padding-x-md': `${ paddingXMd }`,
		'--gutenslider-padding-x-sm': `${ paddingXSm }`,
		'--gutenslider-padding-y': `${ paddingY }`,
		'--gutenslider-padding-y-md': `${ paddingYMd }`,
		'--gutenslider-padding-y-sm': `${ paddingYSm }`,
		'--gutenslider-padding-y-mobile': `${ spacingYMobile }${ spacingYUnit }`,
		'--gutenslider-padding-x-mobile': `${ spacingXMobile }${ spacingXUnit }`,
		'--gutenslider-padding-y-tablet': `${ spacingYTablet }${ spacingYUnit }`,
		'--gutenslider-padding-x-tablet': `${ spacingXTablet }${ spacingXUnit }`,
		'--gutenslider-padding-y-desktop': `${ spacingYDesktop }${ spacingYUnit }`,
		'--gutenslider-padding-x-desktop': `${ spacingXDesktop }${ spacingXUnit }`,
		'--gutenslider-margin-x': `${ marginX }`,
		'--gutenslider-margin-x-md': `${ marginXMd }`,
		'--gutenslider-margin-x-sm': `${ marginXSm }`,
		'--gutenslider-margin-y': `${ marginY }`,
		'--gutenslider-margin-y-md': `${ marginYMd }`,
		'--gutenslider-margin-y-sm': `${ marginYSm }`,
		'--gutenslider-divider-top': `${ dividers.top.height }px`,
		'--gutenslider-divider-bottom': `${ dividers.bottom.height }px`,
	};

	const blockProps = useBlockProps( {
		className: classes,
		style: componentStyle,
		ref: wrapperRef,
		onClick: onSliderClick,
	}, {
		id:`gutenslider-${ gsBlockId }`,
		renderAppender: false,
	});

	const hasTopDivider =
		dividers
		&& dividers.top
		&& dividers.top.value
		&& dividers.top.value !== 'none'
		&& animation !== 'flip'
		&& animation !== 'cube'
		&& animation !== 'cards'
		&& typeof DIVIDER_OPTIONS[ dividers.top.value ] !== 'undefined';
	const hasBottomDivider =
		dividers
		&& dividers.bottom
		&& dividers.bottom.value
		&& dividers.bottom.value !== 'none'
		&& animation !== 'flip'
		&& animation !== 'cube'
		&& animation !== 'cards'
		&& typeof DIVIDER_OPTIONS[ dividers.bottom.value ] !== 'undefined';
	const dividerTopClassNames = hasTopDivider ? classnames( 'gutenslider-divider-top',
		{
			'flip-y': dividers.top.flipY,
			'inverted': DIVIDER_OPTIONS[ dividers.top.value ]['svg-inverted'] && dividers.top.inverted
		}
	) : 'gutenslider-divider-top';
	const dividerBottomClassNames = hasBottomDivider ? classnames( 'gutenslider-divider-bottom',
		{
			'flip-y': dividers.bottom.flipY,
			'inverted': DIVIDER_OPTIONS[ dividers.bottom.value ][ 'svg-inverted' ] && dividers.bottom.inverted
		}
	) : 'gutenslider-divider-bottom';

	let _useInnerBlocksProps;
	if ( typeof useInnerBlocksProps === 'function' ) {
		_useInnerBlocksProps = useInnerBlocksProps;
	} else {
		_useInnerBlocksProps = __experimentalUseInnerBlocksProps;
	}

	const { children, ...innerBlocksProps } = _useInnerBlocksProps( {}, {
		orientation: 'horizontal',
		__experimentalCaptureToolbars: true,
	} );

	const hasMedia = !! media.length;

	const mediaPlaceholder = (
		<Placeholder
			icon={ icons.gutenslider }
			label={ 'Gutenslider Pro' }
			instructions={ __( 'Select background media from your library or add an empty slide.', 'gutenslider' ) }
			className={ className }
		>
			<MediaUploadCheck>
				<MediaUpload
					icon={ ! hasMedia && icons.gutenslider }
					labels={ {
						title: ! hasMedia && __( 'Gutenslider' ),
						instructions: ! hasMedia && PLACEHOLDER_TEXT,
					} }
					onSelect={ onSelectMedia }
					accept="image/*,video/*"
					allowedTypes={ ALLOWED_MEDIA_TYPES }
					multiple
					value={ innerSlides.map( ( slide ) => {
						return slide.attributes.background.mediaId;
					} ) }
					render={ ( { open } ) => (
						<Button
							isPrimary={ true }
							icon={ 'admin-media' }
							onClick={ open }
						>
							{ __( 'Media Library' ) }
						</Button>
					) }
					onError={ onUploadError }
					notices={ hasMedia ? undefined : noticeUI }
					onFocus={ onFocus }
				/>
			</MediaUploadCheck>
			<Button
				isSecondary={ true }
				icon={ 'plus' }
				onClick={ insertEmptySlide }
			>
				{ __( 'Add Empty Slide', 'gutenslider' ) }
			</Button>
		</Placeholder>
	);

	if ( innerSlides.length === 0 ) {
		return <div { ...blockProps }>{ mediaPlaceholder }</div>;
	}

	let dividerTopSvg = '';
	let dividerBottomSvg = '';

	if ( typeof DIVIDER_OPTIONS[ dividers.top.value ] !== 'undefined' ) {
		dividerTopSvg =
			dividers.top.inverted
			&& DIVIDER_OPTIONS[ dividers.top.value ]['svg-inverted']
			? DIVIDER_OPTIONS[ dividers.top.value ]['svg-inverted']
			: DIVIDER_OPTIONS[ dividers.top.value ].svg;
	}

	if ( typeof DIVIDER_OPTIONS[ dividers.bottom.value ] !== 'undefined' ) {
		dividerBottomSvg =
			dividers.bottom.inverted
			&& DIVIDER_OPTIONS[ dividers.bottom.value ]['svg-inverted']
			? DIVIDER_OPTIONS[ dividers.bottom.value ]['svg-inverted']
			: DIVIDER_OPTIONS[ dividers.bottom.value ].svg;
	}
	return (
		<>
			<AutoSlidesContext.Provider value={ getResponsiveSlidesPerView() === 'auto' }>
			<GutensliderBlockControls onSelect={ onSelectMedia } { ...props } />
			<GutensliderInspectorControls { ...props } deviceType={ newDeviceType } />
			<div { ...blockProps }>
				{/* <BoxControlVisualizer
					values={ styleAttribute?.spacing?.margin }
					showValues={ styleAttribute?.visualizers?.margin }
				/> */}
				{ hasTopDivider &&
					<div
						className={ dividerTopClassNames }
						style={ {
							color: dividers.top.color,
							height: `${ dividers.top.height }px`,
						} }
						dangerouslySetInnerHTML={ {
							__html: dividerTopSvg,
						} }
					/>
				}
				{ contentMode === 'fixed' && <div id={ `gutenslider-${ gsBlockId }` } className={ outerClasses }>
					<Swiper
						modules={ [ Navigation, Pagination, EffectCoverflow, EffectCube, EffectFade, EffectCards, EffectFlip, A11y, Autoplay, Lazy ] }
						onSwiper={ swiper }
						key={ swiperUpdateKey }
						{ ...swiperProps }
						{ ...innerBlocksProps }
					>
						{ innerSlides.map( ( block ) => {
							return (
								<SwiperSlide>
									<ServerSideRender
										{ ...block }
										key={ block.clientId }
										block="eedee/block-gutenslide"
										attributes={ block.attributes }
										innerBlocks={ block.innerBlocks }
									/>
								</SwiperSlide>
							);
						} ) }
					</Swiper>
					<div className="fixed-content-edit wp-block-eedee-gutenslider__content">
						{ children }
					</div>
					{ getNextArrow() }
					{ getPrevArrow() }
					{ getPagination() }
					{ hasBottomDivider &&
						<div
							className={ dividerBottomClassNames }
							style={ {
								color: dividers.bottom.color,
								height: `${ dividers.bottom.height }px`,
							} }
							dangerouslySetInnerHTML={ {
								__html: dividerBottomSvg,
							} }
						/>
					}
				</div> }

				{ contentMode === 'change' && <div id={ `gutenslider-${ gsBlockId }` } className={ outerClasses }>
					<Swiper
						onSwiper={ swiper }
						key={ swiperUpdateKey }
						modules={ [ Navigation, Pagination, EffectCoverflow, EffectCube, EffectFade, EffectFlip, EffectCards, A11y, Autoplay, Lazy ] }
						{ ...innerBlocksProps }
						{ ...swiperProps }
					>
						{ children }
					</Swiper>
					{ getNextArrow() }
					{ getPrevArrow() }
					{ getPagination() }
					{ hasBottomDivider &&
						<div
							className={ dividerBottomClassNames }
							style={ {
								color: dividers.bottom.color,
								height: `${ dividers.bottom.height }px`,
							} }
							dangerouslySetInnerHTML={ {
								__html: dividerBottomSvg,
							} }
						/>
					}
				</div> }
				<div
					className="eedee-gutenslider-add-empty"
					style={ { display: props.isSelected ? 'block' : 'none' } }
				>
					<Button
						visible={ props.isSelected.toString() }
						className="block-editor-button-block-appender"
						label={ __( 'Add a new slide with empty background. You can change the background in the slide block settings.' ) }
						onClick={ insertEmptySlide }
						isPrimary
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" role="img" aria-hidden="true" focusable="false"><path d="M18 11.2h-5.2V6h-1.6v5.2H6v1.6h5.2V18h1.6v-5.2H18z"></path></svg>
						{ __( 'Add Empty Slide', 'gutenslider' ) }
					</Button>
				</div>
			</div>
			</AutoSlidesContext.Provider>
		</>
	);
}

export default compose( [
	withDispatch( ( dispatch, ownProps, registry ) => {
		const { getBlockOrder, getBlock, getBlocks } = registry.select( 'core/block-editor' );
		const {
			selectBlock,
			replaceInnerBlocks,
		} = dispatch( 'core/block-editor' );

		// const selectActiveBlock = ( index ) => {
		// 	selectBlock( getBlockOrder( ownProps.clientId )[ index ] );
		// }

		const updateBlockIds = () => {
			const { setAttributes, clientId, attributes } = ownProps;
			const { updateBlockAttributes } = dispatch( 'core/block-editor' );
			const { gsBlockId } = attributes;

			const isBlockIdUnique = ( idInQuestion ) => getBlocks().filter(
				( { attributes: { gsBlockId: otherId } } ) =>
					otherId !== undefined && otherId === idInQuestion
			).length <= 1

			if ( ! gsBlockId || typeof gsBlockId === 'undefined' || gsBlockId === '' || ! isBlockIdUnique( gsBlockId ) ) {
				setAttributes( {
					gsBlockId: Math.random().toString( 36 ).substr( 2, 9 ),
				} );
			}

			const innerBlockIds = getBlockOrder( clientId );

			innerBlockIds.forEach( ( innerBlockId ) => {
				const { attributes } = getBlock( innerBlockId );
				const { gsBlockId: innerGsBlockId } = attributes;
				if ( ! innerGsBlockId || typeof innerGsBlockId === 'undefined' || innerGsBlockId === '' || ! isBlockIdUnique( innerGsBlockId ) ) {
					updateBlockAttributes( innerBlockId, {
						gsBlockId: Math.random().toString( 36 ).substr( 2, 9 ),
					} );
				}
			} );
		};

		const updateContentPosition = ( contentPosition ) => {
			const { updateBlockAttributes } = dispatch( 'core/block-editor' );
			const { setAttributes, clientId } = ownProps;

			setAttributes( { contentPosition } );
			const innerBlockIds = getBlockOrder( clientId );
			innerBlockIds.forEach( ( innerBlockId ) => {
				updateBlockAttributes( innerBlockId, {
					contentPosition,
				} );
			} );
		};

		const updateCaptions = ( val ) => {
			const { updateBlockAttributes } = dispatch( 'core/block-editor' );
			const { setAttributes } = ownProps;
			const innerBlocks = registry.select( 'core/block-editor' ).getBlocks( ownProps.clientId );
			const innerSlides = filter( innerBlocks, { name: 'eedee/block-gutenslide' } );
			setAttributes( { autoCaption: val } );
			innerSlides.forEach( ( slide ) => {
				updateBlockAttributes( slide.clientId, {
					autoCaption: val,
				} );
			} );
		};

		return {
			// selectActiveBlock,
			selectBlock,
			getBlockOrder,
			replaceInnerBlocks,
			updateBlockIds,
			updateContentPosition,
			updateCaptions,
		}
	} ),
	withSelect( ( select, { clientId } ) => {
		const {
			getBlockIndex,
			getBlockParents,
			getBlockHierarchyRootClientId,
			getBlock,
			hasSelectedInnerBlock,
			getBlocks,
			isBlockSelected,
		} = select( 'core/block-editor' );

		// const index = ( blockId ) => getBlockIndex( blockId, getBlockParents( blockId ) );

		const innerBlocks = getBlocks( clientId );

		let newDeviceTypeFunc = null;
		if ( select( 'core/edit-post' ) ) {
			newDeviceTypeFunc = select( 'core/edit-post' ).__experimentalGetPreviewDeviceType;
		}

		let newDeviceType;
		if ( typeof newDeviceTypeFunc === 'function' ) {
			newDeviceType = newDeviceTypeFunc();
		}

		return {
			// index,
			innerBlocks,
			newDeviceType,
			// true in hasSelectedInnerBlock does deep check
			isStackSelected: isBlockSelected( clientId ) || hasSelectedInnerBlock( clientId, true ),
			// getParentId,
			// getBlockParents,
			// getParentBlock,
			hasSelectedInnerBlock: hasSelectedInnerBlock( clientId, false ),
		};
	} ),
	// withNotices,
	// withViewportMatch( {
	// 	isMobile: '< small',
	// 	isTablet: '< large',
	// 	isDesktop: '>= large',
	// } ),
 ])( Edit )
